/**
 * Questo file file contiene i messaggi di errore HTTP
 * @type Object
 */
oLang.errori = {
    404: 'Pagina non trovata',
    422: 'Dati non corretti',
    500: 'Non va',
}